// Centralised Her Box constants.

export const DEFAULT_CATEGORIES = [
  { value: "All", label: "All", visible: true },
  { value: "Earrings", label: "Earrings", visible: true },
  { value: "Necklaces", label: "Necklaces", visible: true },
  { value: "Sets", label: "Sets", visible: true },
  { value: "Bracelets", label: "Bracelets", visible: true },
  { value: "Rings", label: "Rings", visible: true },
];

export const DEFAULT_MOODS = [
  { value: "Daily Luxe", label: "Daily Luxe", visible: true },
  { value: "Date Glam", label: "Date Glam", visible: true },
  { value: "9 to 5", label: "9 to 5", visible: true },
  { value: "Party Edit", label: "Party Edit", visible: true },
  { value: "Big Moments", label: "Big Moments", visible: true },
  { value: "Gifts for Her", label: "Gifts for Her", visible: true },
];

export const CATEGORIES_FOR_ADMIN = ["Earrings", "Necklaces", "Sets", "Bracelets", "Rings"];
export const COLLECTIONS_FOR_ADMIN = [
  "Daily Luxe", "Date Glam", "9 to 5", "Party Edit", "Big Moments", "Gifts for Her",
];

export const FREE_SHIPPING_THRESHOLD = 1299;
export const STANDARD_SHIPPING = 99;
export const PREPAY_DISCOUNT = 50;

// Indian states & UTs sorted alphabetically
export const INDIAN_STATES = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];
